import { defineComponent as a, ref as n, watch as i } from "vue";
import { useLabeledInput as u } from "./td-longtail-vue-components257.js";
import l from "./td-longtail-vue-components25.js";
import d from "./td-longtail-vue-components19.js";
const c = /* @__PURE__ */ a({
  __name: "radio-group",
  props: {
    id: { type: String, default: void 0 },
    options: { type: Array, required: !0 },
    name: { type: String, required: !0 },
    value: { type: String, default: null },
    errorMessage: { type: String, default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    verticalXs: { type: Boolean },
    verticalSm: { type: Boolean },
    verticalMd: { type: Boolean },
    verticalLg: { type: Boolean }
  },
  emits: ["input"],
  setup(r) {
    const e = r, t = n(e.value), { inputId: o } = u(e);
    return i(e, ({ value: p }) => {
      t.value = p;
    }), { __sfc: !0, props: e, inputValue: t, inputId: o, RadioInput: l, InputWrapper: d };
  }
});
export {
  c as default
};
